import { DownloadOutlined } from "@ant-design/icons";
import React from "react";
import "./index.css";
import html2canvas from "html2canvas";
import miscText from "../../../utils/text/misc.json";

export default function DownloadButton({
  id,
  fileName,
  language,
  title,
  subtitle,
  isSurveyCard,
}) {
  const triggerDownload = () => {
    let graph = document
      .getElementById(id)
      .getElementsByClassName("echarts-for-react")[0]; /* full page */

    let cardContainer = document.createElement("div");
    let cardTitleContainer = document.createElement("h2");
    let cardTitle = document.createElement("strong");
    let cardSubtitle = document.createElement("h4");
    let cardDisclaimer = document.createElement("div");

    cardTitle.innerText = title;
    cardTitleContainer.appendChild(cardTitle);
    cardSubtitle.innerText = subtitle;
    cardDisclaimer.innerText =
      (language === "en" ? "Source: " : "Fuente: ") +
      miscText["source"][language] +
      ", " +
      new Date().getFullYear();

    cardContainer.appendChild(cardTitleContainer);
    cardContainer.appendChild(cardSubtitle);
    cardContainer.appendChild(cardDisclaimer);
    cardContainer.appendChild(graph);

    //Styles

    cardContainer.style.cssText =
      "width: 800px; height: 620px; position: absolute; padding-left: 25px; padding-right: 25px; padding-top: 30px; z-index: 100; background-color: 'white'; left: -1000px;";
    cardTitleContainer.style =
      "margin-bottom: 0px; margin-left: 15px; color: var(--blue-primary);";
    cardSubtitle.style = "margin-top: 0; margin-left: 15px;";
    cardDisclaimer.style =
      "margin: 10px 0 20px 15px; font-size: 12px; font-style: italic; color: grey; z-index: 14;";

    let downloadableSpace = document.getElementById(id + "-dc");

    downloadableSpace.append(cardContainer);

    html2canvas(cardContainer, { allowTaint: false })
      .then(function (canvas) {
        var link = document.createElement("a");
        document.body.appendChild(link);
        link.download = fileName;
        link.href = canvas.toDataURL();
        link.target = "_blank";
        link.click();
      })
      .then(() => {
        let originalGraphPlace;

        if (!isSurveyCard) {
          originalGraphPlace = document
            .getElementById(id)
            .getElementsByClassName("card-graph")[0];
        } else {
          originalGraphPlace = document.getElementById("perception-graph");
        }

        originalGraphPlace.appendChild(graph);

        downloadableSpace.innerHTML = "";
      });
  };

  return (
    <button
      onClick={triggerDownload}
      className={"downloadButton"}
      style={{
        border: "2px var(--blue-primary) solid",
        backgroundColor: "var(--blue-primary)",
        color: "white",
        borderRadius: "40px 40px 40px 40px",
        cursor: "pointer",
      }}
    >
      <DownloadOutlined style={{ marginRight: "10px" }} />
      {language === "en" ? "Download" : "Descargar"}
    </button>
  );
}
